var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-div"},[_c('feather-icon',{staticClass:"back-icon",attrs:{"icon":"ArrowLeftIcon","svgClasses":"text-dark"},on:{"click":_vm.clickOnBack}}),_c('p',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }